import { render, staticRenderFns } from "./StampArea.vue?vue&type=template&id=6b37e864&scoped=true"
import script from "./StampArea.vue?vue&type=script&lang=js"
export * from "./StampArea.vue?vue&type=script&lang=js"
import style0 from "./StampArea.vue?vue&type=style&index=0&id=6b37e864&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b37e864",
  null
  
)

export default component.exports